module.exports = __webpack_public_path__ + "img/katarina_events_21.0334f788.jpg";